import { Input, typo, Button } from '@cycle-app/ui';
import { small } from '@cycle-app/utilities';
import styled from 'styled-components';

export const Top = styled.div`
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
`;

export const StyledButtonBack = styled(Button)`
  --bg: transparent;

  color: ${p => p.theme.colors.text.primary};
  padding: 0px 8px;
  height: 32px;

  svg {
    color: ${p => p.theme.colors.text.disabled};
    transform: rotate(180deg);
  }
`;

export const Label = styled.label`
  ${typo.body500}
`;

export const StyledInput = styled(Input)`
  margin-top: 8px;
`;

export const Container = styled.div`
  flex: none;
  height: 100%;
  width: 300px;
  background-color: ${p => p.theme.colors.sidebar.bg};
  border-right: 1px solid ${p => p.theme.colors.border.primary};

  ${small} {
    display: none;
  }
`;

export const Section = styled.div`
  padding: 24px 16px;

  &:not(:first-child) {
    border-top: 1px solid ${p => p.theme.colors.border.primary};
  }
`;
